
import React from 'react';
import { Grid2X2, Package, Users, ShoppingBag, Store } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { formatCurrency } from '@/lib/utils';
import { Skeleton } from '@/components/ui/skeleton';

interface DashboardOverviewProps {
  totalUsers: number;
  totalAhavexers: number;
  totalProducts: number;
  totalRevenue: number;
  isLoading: boolean;
}

const DashboardOverview: React.FC<DashboardOverviewProps> = ({
  totalUsers,
  totalAhavexers,
  totalProducts,
  totalRevenue,
  isLoading
}) => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 pt-3">
      <Card className="bg-white/10 border-none shadow-sm backdrop-blur-sm">
        <CardContent className="p-4 flex flex-col items-center justify-center text-center">
          <Users className="h-8 w-8 mb-2 text-blue-600" />
          {isLoading ? (
            <Skeleton className="h-8 w-16 bg-gray-200/50" />
          ) : (
            <p className="text-2xl font-bold text-gray-800">{totalUsers}</p>
          )}
          <p className="text-sm text-gray-500">Total Users</p>
        </CardContent>
      </Card>
      
      <Card className="bg-white/10 border-none shadow-sm backdrop-blur-sm">
        <CardContent className="p-4 flex flex-col items-center justify-center text-center">
          <Store className="h-8 w-8 mb-2 text-green-600" />
          {isLoading ? (
            <Skeleton className="h-8 w-16 bg-gray-200/50" />
          ) : (
            <p className="text-2xl font-bold text-gray-800">{totalAhavexers}</p>
          )}
          <p className="text-sm text-gray-500">Ahavexers</p>
        </CardContent>
      </Card>
      
      <Card className="bg-white/10 border-none shadow-sm backdrop-blur-sm">
        <CardContent className="p-4 flex flex-col items-center justify-center text-center">
          <Package className="h-8 w-8 mb-2 text-purple-600" />
          {isLoading ? (
            <Skeleton className="h-8 w-16 bg-gray-200/50" />
          ) : (
            <p className="text-2xl font-bold text-gray-800">{totalProducts}</p>
          )}
          <p className="text-sm text-gray-500">Products</p>
        </CardContent>
      </Card>
      
      <Card className="bg-white/10 border-none shadow-sm backdrop-blur-sm">
        <CardContent className="p-4 flex flex-col items-center justify-center text-center">
          <ShoppingBag className="h-8 w-8 mb-2 text-orange-600" />
          {isLoading ? (
            <Skeleton className="h-8 w-16 bg-gray-200/50" />
          ) : (
            <p className="text-2xl font-bold text-gray-800">{formatCurrency(totalRevenue)}</p>
          )}
          <p className="text-sm text-gray-500">Total Revenue</p>
        </CardContent>
      </Card>
    </div>
  );
};

export default DashboardOverview;
